<footer class="footer view-type-{{ viewType$ | async }}">
  <div class="container-fluid">
    <div class="row" *transloco="let t">
      <div class="col-sm-12">
        {{ t("footer.text", { title: title, year: year, patentNotice: patentNotice }) }}
      </div>
    </div>
  </div>
</footer>
